import { createValidIcon } from '@ui/icons/utils/type-helper'

export const LayersIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20.4453 15.168C20.9048 14.8616 21.5257 14.9858 21.832 15.4453C22.1384 15.9048 22.0142 16.5257 21.5547 16.832L12.5547 22.832C12.2188 23.0559 11.7812 23.0559 11.4453 22.832L2.44531 16.832C1.98581 16.5257 1.86168 15.9048 2.16797 15.4453C2.47432 14.9858 3.09516 14.8616 3.55469 15.168L12 20.7979L20.4453 15.168ZM20.4453 11.168C20.9048 10.8616 21.5257 10.9858 21.832 11.4453C22.1384 11.9048 22.0142 12.5257 21.5547 12.832L12.5547 18.832C12.2188 19.0559 11.7812 19.0559 11.4453 18.832L2.44531 12.832C1.98581 12.5257 1.86168 11.9048 2.16797 11.4453C2.47432 10.9858 3.09516 10.8616 3.55469 11.168L12 16.7979L20.4453 11.168ZM11.5752 1.09473C11.8887 0.947534 12.2606 0.971936 12.5547 1.16797L21.5547 7.16797C21.8329 7.35343 22 7.66565 22 8C22 8.33433 21.8329 8.64658 21.5547 8.83203L12.5547 14.832C12.2188 15.0559 11.7812 15.0559 11.4453 14.832L2.44531 8.83203C2.16714 8.64658 2.00002 8.33433 2 8C2 7.66567 2.16715 7.35344 2.44531 7.16797L11.4453 1.16797L11.5752 1.09473ZM4.80273 8L12 12.7979L19.1973 8L12 3.20117L4.80273 8Z'
        fill={color}
      />
    </svg>
  )
})
